/**
 * When fn is called, ignore any repeated call for lockoutPeriod in milliseconds.
 *
 * @param fn - function to wrap.
 * @param wait - time to block all calls after initial call.
 */

export function throttle<T extends unknown[], R>(
  this: R,
  fn: (...args: T) => void,
  wait = 0
): (...args: T) => void {
  let time = Date.now();
  /* eslint-disable  @typescript-eslint/no-this-alias */
  const self = this;

  return function throttleWrapper(...args: T): void {
    if (time + wait - Date.now() < 0) {
      fn.bind(self)(...args);
      time = Date.now();
    }
  };
}
